export function formatChartPercent(percentDecimals: number | undefined) {
    if (percentDecimals === undefined) return "";
    return Math.round(percentDecimals * 100) + "%";
}

export function formatChartAmount(amount: number | undefined) {
    if (amount === undefined) return "";
    return Intl.NumberFormat([], { notation: "compact" }).format(amount);
}
